import { useMemo } from 'react';
import { TariffVerificationTypeEnum } from '@src/core/buyerApiClient';
import { useTranslate } from '@src/core/hooks';

/**
 * Hook to handle tariff verification error logic and messages
 */
export const useTariffVerificationErrorHandling = (
  hasFieldError: boolean,
  hasCartTariffVerificationError: boolean,
  tariffType: TariffVerificationTypeEnum,
) => {
  const { i18n } = useTranslate();

  const hasCartErrorAndIsNotBinCode = useMemo(
    () => hasCartTariffVerificationError && tariffType !== TariffVerificationTypeEnum.BinCode,
    [hasCartTariffVerificationError, tariffType],
  );

  const errorMessage = useMemo(() => {
    if (hasFieldError) {
      return i18n('adder_tariff_verification_field_required');
    }

    if (hasCartErrorAndIsNotBinCode) {
      switch (tariffType) {
        case TariffVerificationTypeEnum.Document:
          return i18n('adder_tariff_verification_document_validation_error');
        case TariffVerificationTypeEnum.Date:
          return i18n('adder_tariff_verification_date_validation_error');
        default:
          return i18n('adder_tariff_verification_validation_error');
      }
    }

    return undefined;
  }, [hasFieldError, hasCartErrorAndIsNotBinCode, tariffType, i18n]);

  const shouldShowError = useMemo(() => {
    return hasFieldError || hasCartErrorAndIsNotBinCode;
  }, [hasFieldError, hasCartErrorAndIsNotBinCode]);

  return { errorMessage, shouldShowError };
};
